import React, { Suspense } from "react";
import _SmsLog from "../../components/reports/smslogs/_SmsLog";
import Loading from "../../components/ui/Suspense";
const LogMessages = () => {
  return (
    <Suspense fallback={<Loading />}>
      <_SmsLog />
    </Suspense>
  );
};

export default LogMessages;
